import React from 'react';
import styles from './index.module.less';
import CompSubCateProducts from './CompSubCateProducts';
import { ReoLink } from '@reolink-web/components.basic';

import type * as I from '@/interface/product';
import classNames from 'classnames';
import { categoryKeyUrlMap, HeaderContext } from '@/components/ReolinkHeader/common';
import { getOfficialSitePath, getStorePath } from '@/utils/function/sitePath';
interface IProductListProps {
    categoryData?: I.INavProductCategoryItem;
    className?: string;
    style?: React.CSSProperties;
}

const CompProductList: React.FC<IProductListProps> = (props) => {
    const { getTextByKey } = React.useContext(HeaderContext);

    return (
        <div
            className={ classNames(styles['product-list-wrapper'], props.className) }
            style={ props.style }>
            {props.categoryData ? (
                <>
                    <ul className={ styles['product-list'] }>
                        {props.categoryData?.subCategory.map((item) => {
                            return (
                                <CompSubCateProducts
                                    key={ item.id }
                                    { ...item } />
                            );
                        })}
                    </ul>
                    <div className={ styles['product-list-footer'] }>
                        <ReoLink
                            href={ categoryKeyUrlMap[props.categoryData.slug]?.more ?? getStorePath() }
                            size={ 'small' }
                            className={ styles['product-list-footer-link'] }
                        >
                            {getTextByKey('more-products')}
                        </ReoLink>
                        <ReoLink
                            href={
                                categoryKeyUrlMap[props.categoryData.slug]?.comparison ??
                                getOfficialSitePath(`/comparison/`)
                            }
                            size={ 'small' }
                            className={ styles['product-list-footer-link'] }
                        >
                            {getTextByKey('product-comparison')}
                        </ReoLink>
                        <ReoLink
                            href={ getOfficialSitePath(`/solution-finder/`) }
                            size={ 'small' }
                            className={ styles['product-list-footer-link'] }
                        >
                            {getTextByKey('solution-finder')}
                        </ReoLink>
                        <ReoLink
                            href={ getStorePath() }
                            size={ 'small' }
                            className={ classNames(
                                styles['product-list-footer-link'],
                                styles['product-list-footer-link-store'],
                            ) }
                        >
                            {getTextByKey('store')}
                        </ReoLink>
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default CompProductList;
